import styled from "styled-components";

export const Title = styled.h1`
  font-size: 20px;
  font-weight: 600;
  color: #191c1a;
`;

/** Cópia do `UploadContainer` do TemplateDataGovernance — importar de outra página acoplaria as duas. */
export const UploadContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
  padding: 20px;
  border-width: 2px;
  border-radius: 12px;
  cursor: pointer;
  background-color: #fff;
  color: #7c3aed;
  outline: none;
  transition: border 0.24s ease-in-out;
  background-image: url("data:image/svg+xml,%3Csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%233024E180' stroke-width='5' stroke-dasharray='12%2C12' stroke-linecap='round'/%3E%3C/svg%3E");
`;
